import { lazy, Suspense } from "react";

const TransactionReviewPanel = lazy(
  () => import("./TransactionReviewPanel.jsx")
);

export default function TransactionReviewsSection({
  orders,
  reviewData,
  userId,
  disputes,
  disputesLoaded,
  disputesError,
  loading,
  error,
  onRetry,
  onSubmitted,
  onReportSubmitted,
  onReportRetry,
}) {
  const completedOrders = orders.filter(
    (order) =>
      order.payment_state === "cash_completed" &&
      reviewData[order.id]?.handoffStatus === "completed"
  );

  return (
    <section
      className="order-reviews"
      aria-labelledby="order-reviews-heading"
    >
      <h2 id="order-reviews-heading">Transaction reviews</h2>
      <p className="section-intro">
        Reviews open only after both participants confirm the cash handoff.
        Disputed orders wait for resolution.
      </p>
      {loading && <p role="status">Loading completed transactions…</p>}
      {error && (
        <p className="marketplace-load-error" role="alert">
          Could not load completed transaction reviews: {error}{" "}
          <button type="button" onClick={onRetry}>
            Retry
          </button>
        </p>
      )}
      {!loading && !error && completedOrders.length === 0 && (
        <p className="marketplace-empty">
          Completed cash handoffs will appear here when they are ready for
          review.
        </p>
      )}
      {completedOrders.map((order) => {
        const data = reviewData[order.id];
        return (
          <article className="order-review-card" key={order.id}>
            <h3>{order.item_name}</h3>
            <p>
              {order.local_offer_id ? "Local errand" : "Trip request"} ·{" "}
              {order.delivery_city}
            </p>
            <Suspense
              fallback={<p role="status">Loading transaction review…</p>}
            >
              <TransactionReviewPanel
                order={order}
                userId={userId}
                handoffStatus={data?.handoffStatus}
                reviews={data?.reviews}
                reviewReports={data?.reviewReports}
                reviewReportsError={data?.reviewReportsError}
                dispute={disputes[order.id]}
                disputesLoaded={disputesLoaded}
                disputesError={disputesError}
                loading={loading}
                loadError={error}
                onSubmitted={(review) => onSubmitted(order.id, review)}
                onReportSubmitted={(report) =>
                  onReportSubmitted(order.id, report)
                }
                onReportRetry={onReportRetry}
              />
            </Suspense>
          </article>
        );
      })}
    </section>
  );
}
